import { DriveFile } from '@/modules/drive/domain/models/DriveFile'

import { axios, Response } from '../index'

export default async function getFolderFiles(
  personaId: string,
  folderId: string
): Response<DriveFile[]> {
  return await axios.get(`/v1/personas/${personaId}/folders/${folderId}/files`)
}
